import React, { memo } from "react";
import Ellipses from "../Ellipses";
import PropTypes from "prop-types";
import "./style.scss";
import BackButton from "../BackButton";

function BaseFormPage({
  children,
  backTo,
  linkRoute,
  routeTitle,
  className,
  onNavigate,
  renderActionFormButton,
  renderLangSwitch,
}) {
  BaseFormPage.propTypes = {
    children: PropTypes.node,
    backTo: PropTypes.string,
    className: PropTypes.string,
    onNavigate: PropTypes.func,
    linkRoute: PropTypes.string,
    routeTitle: PropTypes.string,
    renderActionFormButton: PropTypes.func,
    renderLangSwitch: PropTypes.func,
  };
  const cls = ["page-wrapper centering-page"];

  if (className) cls.push(className);
  return (
    <div className={cls.join(" ")}>
      <Ellipses className="page-ellipse" countEllipses={1} />
      <div className="page-wrapper__action">
        <div className="page-wrapper__action__form">
          <div className="page-wrapper__action-form-button">
            {renderActionFormButton?.(linkRoute, routeTitle)}
          </div>
          <div className="page-wrapper__back-btn">
            {backTo || onNavigate ? (
              <BackButton
                className="page-wrapper__action__form__optional-btns__btn-back"
                onClick={onNavigate}
                to={backTo}
              />
            ) : null}
          </div>
          {/* item 29: слот под переключатель языка (регистрация) — глобус RU/EN */}
          {renderLangSwitch ? (
            <div className="page-wrapper__lang-switch">{renderLangSwitch()}</div>
          ) : null}
          {children}
        </div>
      </div>
    </div>
  );
}

export default memo(BaseFormPage);
